import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";

import {AppComponent} from "./app.component";
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {PlaceComponent} from "./places-to-go/place.component";
import {ValidationService} from "./services/validation.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ControlMessagesComponent} from "./control-messages/control-messages.component";
import {HttpClientJsonpModule, HttpClientModule} from "@angular/common/http";
import {Angular2SocialLoginModule} from "angular2-social-login";
import {Conf} from "./settings/config";
import {HeaderComponent} from "./header/header.component";
import {FooterComponent} from "./footer/footer.component";
import {EssentialsComponent} from "./essentials/essentials.component";
import {SearchBarComponent} from "./search-bar/search-bar.component";
import {LoginComponent} from "./dialogs/login/login.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {PagesComponent} from "./pages/pages.component";
import {AttractionsComponent} from "./attractions/attractions.component";
import {AgmCoreModule} from "@agm/core";
import {NgxGalleryModule} from "ngx-gallery";
import {CarouselDirective} from "./directives/carousel.directive";
import {MenuDirective} from "./directives/menu.directive";
import {OwlModule} from "ng2-owl-carousel";
import {AttractionsListComponent} from "./attractions-list/attractions-list.component";
import {IonRangeSliderModule} from "ng2-ion-range-slider";
import {AccommodationListComponent} from "./accommodation-list/accommodation-list.component";
import {ShareModule} from "@ngx-share/core";
import {ShareButtonsModule} from "@ngx-share/buttons";
import {WhatsOnComponent} from "./whats-on/whats-on.component";
import {BeInspiredComponent} from "./be-inspired/be-inspired.component";
import {FooterLinkAreaComponent} from "./footer-link-area/footer-link-area.component";
import {TradePressComponent} from "./trade-press/trade-press.component";
import {FollowComponent} from "./follow/follow.component";
import {MeetingsComponent} from "./meetings/meetings.component";
import {BeInspiredListComponent} from "./be-inspired-list/be-inspired-list.component";
import {EatDrinkListComponent} from "./eat-drink-list/eat-drink-list.component";
import {ToursComponent} from "./tours/tours.component";
import {WhatsOnListComponent} from "./whats-on-list/whats-on-list.component";
import {FunctionsService} from "./services/functions.service";
import {OffersListComponent} from "./offers-list/offers-list.component";
import {OffersComponent} from "./offers/offers.component";
import {CompetitionsComponent} from "./competitions/competitions.component";
import {CompetitionsListComponent} from "./competitions-list/competitions-list.component";
import {AuthServices} from "./services/auth.service";
import {SignupComponent} from "./dialogs/signup/signup.component";
import {ForgotComponent} from "./dialogs/forgot/forgot.component";
import {ResetComponent} from "./dialogs/reset/reset.component";
import {AccommodationsComponent} from "./accommodations/accommodations.component";
import {MalihuScrollbarModule} from "ngx-malihu-scrollbar";
import {ScriptLoaderService} from "./services/script-loader.service";
import {RoundPipe} from "./pipes/round.pipe";
import {ConvertStringPipe} from "./pipes/convert-string.pipe";
import {FunctionsDirective} from "./directives/functions.directive";
import {StarRatingComponent} from "./star-rating/star-rating.component";
import {AttractionReviewComponent} from "./attraction-review/attraction-review.component";
import {StarRatingDirective} from "./directives/star-rating.directive";
import {AccommodationReviewComponent} from "./accommodation-review/accommodation-review.component";
import {ScrollToFirstInvalidDirective} from "./directives/scroll-to-first-invalid.directive";
import {EatDrinkReviewComponent} from "./eat-drink-review/eat-drink-review.component";
import {TourReviewComponent} from "./tour-review/tour-review.component";
import {MeetingInspireComponent} from "./meeting-inspire/meeting-inspire.component";
import {MeetingInspireListComponent} from "./meeting-inspire-list/meeting-inspire-list.component";
import {PlanYourEventsComponent} from "./plan-your-events/plan-your-events.component";
import {NotFoundComponent} from "./not-found/not-found.component";
import {EssentialComponent} from "./essential/essential.component";
import {SafeHtmlPipe} from "./pipes/safe-html.pipe";
import {ApiService} from "./services/api.service";
import {DetailsComponent} from "./dialogs/details/details.component";
import {NgxPageScrollModule} from "ngx-page-scroll";
import { EatDrinkSingleComponent } from './eat-drink-single/eat-drink-single.component';
import { FloorPipe } from './pipes/floor.pipe';


const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: '404', component: NotFoundComponent},
    {path: 'places-to-go/:slug', component: PlaceComponent},

    {path: 'essentials', component: EssentialsComponent},
    {path: 'essentials/:slug', component: EssentialsComponent},
    {path: 'essentials/:category/:slug', component: EssentialComponent},

    {path: 'things-to-do', component: AttractionsListComponent},

    {path: 'things-to-do/attractions', component: AttractionsListComponent},
    {path: 'things-to-do/shopping', component: AttractionsListComponent},
    {path: 'things-to-do/art-entertainment', component: AttractionsListComponent},
    {path: 'things-to-do/tours-and-activities', component: AttractionsListComponent},

    {path: 'things-to-do/attractions/:slug', component: AttractionsListComponent},
    {path: 'things-to-do/shopping/:slug', component: AttractionsListComponent},
    {path: 'things-to-do/art-entertainment/:slug', component: AttractionsListComponent},
    {path: 'things-to-do/tours-and-activities/:slug', component: AttractionsListComponent},
    {path: 'things-to-do/review/:slug', component: AttractionReviewComponent},
    {path: 'tours-and-activities/review/:slug', component: TourReviewComponent},


    {path: 'attractions/:slug', component: AttractionsComponent},
    {path: 'shopping/:slug', component: AttractionsComponent},
    {path: 'art-entertainment/:slug', component: AttractionsComponent},
    {path: 'tours-and-activities/:slug', component: ToursComponent},

    {path: 'accommodations', component: AccommodationListComponent},
    {path: 'accommodations/:slug', component: AccommodationListComponent},
    {path: 'accommodations/:category/:slug', component: AccommodationsComponent},
    {path: 'accommodation/review/:slug', component: AccommodationReviewComponent},

    {path: 'eat-and-drink', component: EatDrinkListComponent},
    {path: 'eat-and-drink/:slug', component: EatDrinkListComponent},
    {path: 'eat-and-drink/:category/:slug', component: EatDrinkSingleComponent},
    {path: 'eat-drink/review/:slug', component: EatDrinkReviewComponent},

    {path: 'be-inspired', component: BeInspiredListComponent},
    {path: 'be-inspired/:slug', component: BeInspiredListComponent},
    {path: 'be-inspired/:category/:slug', component: BeInspiredComponent},

    {path: 'what-is-on', component: WhatsOnListComponent},
    {path: 'what-is-on/category/:slug', component: WhatsOnListComponent},
    {path: 'what-is-on/:slug', component: WhatsOnComponent},

    {path: 'competitions', component: CompetitionsListComponent},
    {path: 'competitions/:slug', component: CompetitionsListComponent},
    {path: 'competition/:slug', component: CompetitionsComponent},

    {path: 'offers', component: OffersListComponent},
    {path: 'offers/:slug', component: OffersListComponent},
    {path: 'offers/:category/:slug', component: OffersComponent},

    {path: 'trade-and-press/:slug', component: TradePressComponent},

    {path: 'meetings/inspire', component: MeetingInspireListComponent},
    {path: 'meetings/inspire/:slug', component: MeetingInspireListComponent},
    {path: 'meetings/inspire/:category/:slug', component: MeetingInspireComponent},

    {path: 'meetings/plan-your-event', component: PlanYourEventsComponent},
    {path: 'meetings/plan-your-event/:slug', component: PlanYourEventsComponent},

    {path: 'meetings/:slug', component: MeetingsComponent},
    {path: ':slug', component: PagesComponent},
    // {path: '**', redirectTo: 'index',}
];

@NgModule({
    entryComponents: [
        LoginComponent,
        SignupComponent,
        ForgotComponent,
        ResetComponent,
        HeaderComponent,
        DetailsComponent
    ],
    declarations: [
        AppComponent,
        ControlMessagesComponent,
        HomeComponent,
        PlaceComponent,
        HeaderComponent,
        FooterComponent,
        EssentialsComponent,
        SearchBarComponent,
        LoginComponent,
        PagesComponent,
        AttractionsComponent,
        CarouselDirective,
        MenuDirective,
        AttractionsListComponent,
        AccommodationListComponent,
        WhatsOnComponent,
        BeInspiredComponent,
        FooterLinkAreaComponent,
        TradePressComponent,
        FollowComponent,
        MeetingsComponent,
        BeInspiredListComponent,
        EatDrinkListComponent,
        ToursComponent,
        WhatsOnListComponent,
        OffersListComponent,
        OffersComponent,
        CompetitionsComponent,
        CompetitionsListComponent,
        SignupComponent,
        ForgotComponent,
        ResetComponent,
        AccommodationsComponent,
        RoundPipe,
        ConvertStringPipe,
        FunctionsDirective,
        StarRatingComponent,
        AttractionReviewComponent,
        StarRatingDirective,
        AccommodationReviewComponent,
        ScrollToFirstInvalidDirective,
        EatDrinkReviewComponent,
        TourReviewComponent,
        MeetingInspireComponent,
        MeetingInspireListComponent,
        PlanYourEventsComponent,
        NotFoundComponent,
        EssentialComponent,
        SafeHtmlPipe,
        DetailsComponent,
        EatDrinkSingleComponent,
        FloorPipe
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        Angular2SocialLoginModule,
        NgbModule.forRoot(),
        RouterModule.forRoot(routes),
        AgmCoreModule.forRoot({
            apiKey: Conf.google_api_key
        }),
        NgxGalleryModule,
        OwlModule,
        IonRangeSliderModule,
        HttpClientJsonpModule,
        ShareModule.forRoot(),
        ShareButtonsModule.forRoot(),
        MalihuScrollbarModule.forRoot(),
        NgxPageScrollModule
    ],
    providers: [
        ValidationService,
        FunctionsService,
        AuthServices,
        ScriptLoaderService,
        HeaderComponent,
        ApiService
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}

Angular2SocialLoginModule.loadProvidersScripts(Conf.providers);



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/app.module.ts